import { Box, SxProps, Theme } from "@mui/material";
import React from "react";

export interface ShapeProps {
  variant: "circle" | "rect" | "triangle";
  size: number; // en pixels
  strokeWidth?: number; // épaisseur de la bordure (pour circle / rect)
  fill?: string; // couleur de fond (ou couleur du triangle)
  color?: string; // couleur de bordure (pour circle / rect)
  onClick?: () => void;
  sx?: SxProps<Theme>;
  opacity?: number;
  zIndex?: number;
  animation?: string;
  orientation?: "up" | "down" | "left" | "right"; // orientation du triangle
}

const Shape: React.FC<ShapeProps> = ({
  variant,
  size,
  strokeWidth = 2,
  fill = "transparent",
  color = "white",
  onClick,
  opacity = 1,
  sx,
  orientation = "up",
  animation,
  zIndex,
}) => {
  const baseSx: SxProps<Theme> = {
    opacity,
    display: "inline-block",
    zIndex,
    animation,
  };

  let variantSx: SxProps<Theme> = {};

  if (variant === "circle" || variant === "rect") {
    // Comportement identique à avant pour cercle / rectangle
    variantSx = {
      width: size,
      height: variant === "circle" ? size : size / 1.5,
      border: `${strokeWidth}px solid ${color}`,
      borderRadius: variant === "circle" ? "50%" : 0,
      backgroundColor: fill,
    };
  } else if (variant === "triangle") {
    const half = size / 2;

    // Pour les triangles, on utilise la technique CSS des bordures
    // `fill` est utilisé comme couleur du triangle
    switch (orientation) {
      case "down":
        variantSx = {
          width: 0,
          height: 0,
          borderLeft: `${half}px solid transparent`,
          borderRight: `${half}px solid transparent`,
          borderTop: `${size}px solid ${fill}`,
        };
        break;

      case "left":
        variantSx = {
          width: 0,
          height: 0,
          borderTop: `${half}px solid transparent`,
          borderBottom: `${half}px solid transparent`,
          borderRight: `${size}px solid ${fill}`,
        };
        break;

      case "right":
        variantSx = {
          width: 0,
          height: 0,
          borderTop: `${half}px solid transparent`,
          borderBottom: `${half}px solid transparent`,
          borderLeft: `${size}px solid ${fill}`,
        };
        break;

      case "up":
      default:
        variantSx = {
          width: 0,
          height: 0,
          borderLeft: `${half}px solid transparent`,
          borderRight: `${half}px solid transparent`,
          borderBottom: `${size}px solid ${fill}`,
        };
        break;
    }
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        ...baseSx,
        ...variantSx,
        ...sx,
      }}
    />
  );
};

export default Shape;
